<ion-header>
  <ion-toolbar>
      <div class="modal-top"></div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding model-content">
  <form (ngSubmit)="updateBonus()" [formGroup]="bonusForm">
      <ion-list class="inputLabel">          
          <ion-item class="inputItem" detail="false">
              <ion-label class="addInput-Label" position="floating">Type</ion-label>
              <ion-input class="addInput" formControlName="type" type="text"></ion-input>
          </ion-item>

          <ion-item class="inputItem item-leave-height no-arrow" detail="false">
              <ion-label class="addInput-Label" position="floating">Status</ion-label>
              <ion-select interface="action-sheet" placeholder="Edit bonus status" formControlName="status">
                  <ion-select-option *ngFor="let status of statusList" [value]="status">{{status}}</ion-select-option>
              </ion-select>
          </ion-item>
      </ion-list>

      <ion-button expand="block" type="submit" class="loginButton">Update</ion-button>
  </form>
</ion-content>
